var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2446 5.62604C23.4096 5.99604 22.5126 6.24604 21.5696 6.35904C22.5426 5.77683 23.2705 4.86051 23.6176 3.78104C22.7034 4.32403 21.7029 4.70624 20.6596 4.91104C19.958 4.16191 19.0286 3.66537 18.0159 3.49852C17.0032 3.33166 15.9637 3.50383 15.0588 3.98829C14.154 4.47276 13.4344 5.2424 13.0117 6.17775C12.5891 7.11309 12.4871 8.16179 12.7216 9.16104C10.8693 9.06804 9.0572 8.58659 7.403 7.74795C5.7488 6.9093 4.28942 5.7322 3.11957 4.29304C2.71957 4.98304 2.48957 5.78304 2.48957 6.63504C2.48913 7.40204 2.67801 8.15728 3.03945 8.83377C3.4009 9.51026 3.92374 10.0871 4.56157 10.513C3.82185 10.4895 3.09845 10.2896 2.45157 9.93004V9.99004C2.4515 11.0658 2.82361 12.1084 3.50476 12.941C4.18591 13.7737 5.13415 14.345 6.18857 14.558C5.50236 14.7438 4.78291 14.7711 4.08457 14.638C4.38207 15.5637 4.96157 16.3731 5.74194 16.953C6.52231 17.5329 7.46449 17.8542 8.43657 17.872C6.78641 19.1675 4.74846 19.8701 2.65057 19.867C2.27896 19.8671 1.90765 19.8454 1.53857 19.802C3.66805 21.1712 6.14691 21.8979 8.67857 21.895C17.2486 21.895 21.9336 14.797 21.9336 8.64104C21.9336 8.44104 21.9286 8.23904 21.9196 8.03904C22.8309 7.38002 23.6175 6.56394 24.2426 5.62904L24.2446 5.62604Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.601562 0.689453)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFill);
export default __webpack_public_path__ + "static/media/twitter-fill.069087c073365a4c86c33aa7a83d75ee.svg";
export { ForwardRef as ReactComponent };